import { useEffect, useState } from "react";
import { fetchBanks, downloadBanksExcel } from "../Api/ViewBank";
import { Container, Table, Button } from "react-bootstrap";

import { toast } from "react-toastify";
import moment from "moment";

const ViewBankMaster = () => {
  const [banks, setBanks] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const loadBanks = async () => {
      try {
        const data = await fetchBanks();
        setBanks(data || []);
      } catch (error) {
        toast.error("🦄 Error Fetching Bank Data");
      }
    };

    loadBanks();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadBanksExcel();
      
      // Create a blob from the response data
      const url = window.URL.createObjectURL(new Blob([response.data]));
      
      // Create a temporary anchor element
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'BanksData.xlsx'); // Set the file name
      document.body.appendChild(link);
      
      // Trigger the download
      link.click();
      
      // Clean up
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      toast.success("🦄 Download started successfully!");
    } catch (error) {
      toast.error("🦄 Error downloading bank data");
      console.error("Download error:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    
      <div className="main-content expand">
        <Container fluid className="list-container">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <span className="list-title">View Bank Master</span>
            <Button className="generate-btn"
              variant="primary" 
              onClick={handleDownload}
              disabled={isDownloading || banks.length === 0}
            >
              {isDownloading ? 'Downloading...' : 'Download Data'}
            </Button>
          </div>

          {banks.length > 0 ? (
            <div className="table-wrapper">
              <div className="table-scroll-container">
                <Table bordered hover className="data-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Bank Code</th>
                      <th>Bank Name</th>
                      <th>Company Code</th>
                      <th>Created On</th>
                      <th>Created By</th>
                      <th>Changed On Date</th>
                      <th>Changed On Time</th>
                      <th>Changed By</th>
                    </tr>
                  </thead>
                  <tbody>
                    {banks.map((bank, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{bank.code}</td>
                        <td>{bank.description}</td>
                        <td>{bank.companyCode}</td>
                        <td>
                          {bank.createdOnDate && bank.createdOnTime
                            ? `${moment(bank.createdOnDate).format("L")} at ${bank.createdOnTime.substring(0, 8)}`
                            : "N/A"}
                        </td>
                        <td>{bank.createdBy}</td>
                        <td>{bank.changedOnDate}</td>
                        <td>{bank.changedOnTime}</td>
                        <td>{bank.changedBy}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          ) : (
            <p className="no-data">No banks found.</p>
          )}
        </Container>
      </div>
    
  );
};

export default ViewBankMaster;